import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { getImgPath } from '../../store/JSTool';
import { settingActions, settingObj } from '../../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';

export default function SectionView(props) {

    const settingData = useSelector(state => state.settingData);

    return (
        <Stack
            id={props.id}
            sx={{
                width: 1,
                bgcolor: props.isBlack ? 'black' : 'white',
                justifyContent: 'center',
                alignItems: 'center',
            }}>

            <Stack sx={{
                position: 'relative',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                height: 1,
                width: settingData.isMobile ? 1 : '1200px',
            }}>
                <Stack
                    id={props.id && props.id + '_left'}
                    sx={{
                        position: 'relative',
                        ml: 3,
                        opacity: 0,
                        zIndex: 2,
                    }}>
                    <Box
                        component={'img'}
                        src={getImgPath('comma.png')}
                        sx={{
                            height: settingData.isMobile ? '50px' : '100px',
                            my: 1,
                        }} />

                    <Typography sx={{
                        color: props.isBlack ? 'white' : 'black',
                        left: settingData.isMobile ? '20px' : '45px',
                        mt: settingData.isMobile ? 2.5 : 4,
                        fontFamily: 'Lexend Deca',
                        fontSize: settingData.isMobile ? 20 : 40,
                        position: 'absolute',
                        width: settingData.isMobile ? '200px' : '400px',
                    }}>
                        {props.title}
                    </Typography>

                </Stack>

                <Box sx={{ flex: 1 }} />

                <Box
                    id={props.id && props.id + '_right'}
                    component={'img'}
                    src={props.isBlack ? getImgPath('slogan_black3.png') : getImgPath('slogan_white3.png')}
                    sx={{
                        zIndex: 1,
                        height: settingData.isMobile ? '28px' : 0.6,
                        mr: settingData.isMobile ? 3 : 15,
                        opacity: 0,
                    }} />
            </Stack>

        </Stack>
    );


}